import * as React from 'react';
import {TextArea} from '@sail/ui';

export const Controlled = () => {
  const [textValue, setTextValue] = React.useState();
  return (
    <TextArea
      value={textValue}
      onChange={(e) => {
        setTextValue(e.target.value);
        // eslint-disable-next-line no-console
        console.log(e);
      }}
      label="About your business"
      placeholder="Our business is…"
    />
  );
};
